import { useContext } from 'react';
import { StoryListContext, StoryListContextType } from '#advertStory/list';

const useStoryListContext = () => useContext<StoryListContextType>(StoryListContext);

export { useStoryListContext };
